export default "__VITE_ASSET__7055fb5c__"